<template>
  <div class="account-favorites">
    <h1 class="h3 mb-4">Favorites</h1>
    <b-row v-if="favorites.length">
      <b-col
        v-for="(listing, index) in listings"
        :key="listing.id"
        cols="3">
        <listing-card
          class="mb-4"
          :listing="listing">
          <template slot="actions">
            <a
              @click="removeFavorite(index)"
              class="text-danger"
              href="#">
              Remove from Favorites
            </a>
          </template>
        </listing-card>
      </b-col>
    </b-row>
    <div v-else>
      <b-card
        class="py-5 text-center">
        <h4 class="h5">
          You haven't favorited any listings
        </h4>
        <p>
          When you find a listing you'd like to save for later,
          click <strong>Add to Favorites</strong> to save it
          to your collection.
        </p>
        <b-button
          @click="$router.push('/listings')"
          size="md"
          variant="outline-dark"
          squared>
          Browse Listings
        </b-button>
      </b-card>
    </div>
  </div>
</template>

<script>
import ListingCard from '@/components/listings/ListingCard.vue'
import currency from '@/filters/currency.filter'

export default {
  name: 'AccountFavorites',
  components: {
    ListingCard,
  },
  filters: {
    currency,
  },
  data() {
    return {
      favorites: [],
    }
  },
  methods: {
    async removeFavorite(index) {
      const { id } = this.favorites[index]
      const result = await this.$bvModal.msgBoxConfirm('Are you sure you want to remove this favorite?', {
        title: 'Are you sure?',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes, remove this favorite',
        cancelTitle: 'No, cancel',
        cancelVariant: 'default',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: true,
      })
      if (result === true) {
        await this.$store.dispatch('Favorites/removeFavorite', id)
        this.favorites.splice(index, 1)
      }
    },
  },
  computed: {
    listings() {
      return this.favorites.map(f => ({
        ...f,
        favoritesId: f.id,
        id: f.listingsId,
      }))
    },
  },
  async created() {
    try {
      const { data: { favorites } } = await this.$http.get('/favorites')
      this.favorites = favorites
    } catch (err) {
      console.error(err)
    }
  },
}
</script>
